/**
 * Module dependencies.
 */

import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { appRoutes } from 'app/routes';
import { compileMenu } from 'app/core/utils/menu';
import { Dashboard } from './dashboard';
import { ArrowLeftRight, PieChart, Settings, Wallet } from 'lucide-react';

/**
 * Export `SkinCryptoGest` component.
 *
 * Section shell for Crypto Gest — the incremental Crypto Manager replacement.
 * Starts with a single overview entry; more sections land in later installments.
 */

export function SkinCryptoGest(): JSX.Element {
  const [translate] = useTranslation();
  const items = useMemo(
    () =>
      compileMenu([
        {
          key: '1',
          pathname: appRoutes.dashboard.cryptoGest.base,
          icon: <PieChart className={'h-4 w-4'} />,
          label: translate('cryptoGest.menu.overview')
        },
        {
          key: '2',
          pathname: appRoutes.dashboard.cryptoGest.wallets,
          icon: <Wallet className={'h-4 w-4'} />,
          label: translate('cryptoGest.menu.wallets')
        },
        {
          key: '3',
          pathname: appRoutes.dashboard.cryptoGest.transactions,
          icon: <ArrowLeftRight className={'h-4 w-4'} />,
          label: translate('cryptoGest.menu.transactions')
        },
        {
          key: '4',
          pathname: appRoutes.dashboard.cryptoGest.settings,
          icon: <Settings className={'h-4 w-4'} />,
          label: translate('cryptoGest.menu.settings')
        }
      ]),
    [translate]
  );

  return (
    <Dashboard menu={items}>
      <Outlet />
    </Dashboard>
  );
}
